import { AfterViewInit, Component, ElementRef, HostListener, Input } from '@angular/core';

@Component({
  selector: 'app-dropdown',
  templateUrl: './dropdown.component.html',
  styleUrls: ['./dropdown.component.scss'],
})
export class DropdownComponent implements AfterViewInit {
  @Input() value?: string;
  @Input() disabled = false;
  @Input() isMultipleSelect = false;
  display = false;
  @Input() paddingSize?: number;
  @Input() textColor = '';
  paddingStyle = {};
  @Input() hideClose = false;
  // auto Close the dropdown list when clicked outside the dropdown component
  @Input() autoClose = false;
  @Input() label = null;
  @Input() newDropdown = false;

  constructor(private _elementRef: ElementRef) {}

  ngAfterViewInit() {
    if (this.paddingSize) {
      this.paddingStyle = {
        padding: `${this.paddingSize}px`,
      };
    }
  }

  toggle() {
    this.display = !this.display;
  }

  @HostListener('document:click', ['$event'])
  checkExternalClick($event: PointerEvent): void {
    const clickedElement = $event.target as HTMLElement;

    const ActiveDropdown = (element: HTMLElement | null): boolean => {
      while (element) {
        if (element.classList.contains('dropdown') && element.classList.contains('-active')) {
          return true;
        }
        element = element.parentElement;
      }
      return false;
    };

    if (this._elementRef.nativeElement.contains(clickedElement) && !this.disabled) {
      if (ActiveDropdown(clickedElement)) {
        this.toggle();
      } else {
        this.isMultipleSelect ? (this.display = true) : this.toggle();
      }
    } else if (this.autoClose) {
      this.display = false;
    }
  }
}
